export const SET_LOCAL = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const GET_LOCAL = (key) => {
  return JSON.parse(localStorage.getItem(key)) || null;
};

export const REMOVE_LOCAL = (key) => {
  localStorage.removeItem(key);
};

export const Zoom_User = [
  {
    id: "hTROpj1bQbOYCMoArOtCUg",
    first_name: "Developer",
    last_name: "Testifyi",
    display_name: "Testifyi",
    email: "info@testifyi.com",
    type: 2,
    pmi: 6640209523,
    timezone: "Asia/Calcutta",
    verified: 1,
    dept: "Testifyi",
    created_at: "2025-05-26T09:33:38Z",
    last_login_time: "2025-07-22T08:13:47Z",
    last_client_version: "6.5.6.9328(win)",
    language: "en-US",
    phone_number: "+91 8851468488",
    status: "active",
    role_id: "0",
    user_created_at: "2025-05-26T04:53:05Z",
  },
  {
    id: "zfOoW4XMTDCoFohPiDmudg",
    first_name: "Avinash",
    last_name: "Bharti",
    display_name: "Avinash Bharti",
    email: "trainer@testifyi.com",
    type: 1,
    pmi: 4104801588,
    timezone: "",
    verified: 1,
    dept: "Testifyi",
    created_at: "2025-07-21T09:00:52Z",
    last_login_time: "2025-07-21T09:00:53Z",
    language: "en-US",
    status: "active",
    role_id: "2",
    user_created_at: "2025-07-18T11:16:47Z",
  },
];
